module.exports = __webpack_public_path__ + "static/fonts/Recta.762434e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Recta.ttf
// module id = 334
// module chunks = 0